import { render, staticRenderFns } from "./pages5.vue?vue&type=template&id=3a14175f&scoped=true&"
import script from "./pages5.vue?vue&type=script&lang=js&"
export * from "./pages5.vue?vue&type=script&lang=js&"
import style0 from "./pages5.vue?vue&type=style&index=0&id=3a14175f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a14175f",
  null
  
)

export default component.exports